import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PATH_DASHBOARD } from "../../routes/paths";
import axiosInstance from "../../utils/axios";

const initialState = {
  fetchLoading: false,
  isLoading: false,
  tags: [],
};

export const createTag = createAsyncThunk(
  "createTag/tag",
  async ({ data, enqueueSnackbar, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.post("tags", data);
      enqueueSnackbar("Tag is added successfully");
      navigate(PATH_DASHBOARD.contents.tags.list);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const fetchTags = createAsyncThunk(
  "fetchTags/tag",
  async ({ enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get("tags");
      return {
        data: response.data.data.data,
        meta: {
          total: response.data.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const updateTag = createAsyncThunk(
  "updateTag/tag",
  async ({ id, data, enqueueSnackbar, setOpenEdit, navigate }, thunkApi) => {
    try {
      const response = await axiosInstance.put(`tags/${id}`, data);
      navigate(PATH_DASHBOARD.contents.tags.list);
      return {
        data: response.data.data,
        enqueueSnackbar,
        setOpenEdit,
        id,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

export const deleteTag = createAsyncThunk(
  "deleteTag/tag",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.delete(`tags/${id}`);
      return { id, enqueueSnackbar };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// fetch single tag
export const fetchSingleTag = createAsyncThunk(
  "fetchSingleTag/tag",
  async ({ id, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`tags/${id}`);
      return response.data.data;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const tagSlice = createSlice({
  name: "tags",
  initialState,
  extraReducers: (builder) => {
    // TODO: create product
    builder.addCase(createTag.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createTag.fulfilled, (state) => {
      state.isLoading = false;
    });

    builder.addCase(createTag.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: fetch product
    builder.addCase(fetchTags.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchTags.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.tags = action.payload;
    });

    builder.addCase(fetchTags.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // =================
    builder.addCase(fetchSingleTag.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchSingleTag.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.singleTag = action.payload;
    });

    builder.addCase(fetchSingleTag.rejected, (state, action) => {
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: update product
    builder.addCase(updateTag.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateTag.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar("Tag is updated successfully");
      // state.tags.data = state.tags.data.map((product) =>
      //   product.slug === action.payload.slug ? action.payload.data : product,
      // );
      // action.payload.setOpenEdit(false);
    });

    builder.addCase(updateTag.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================

    // TODO: delete product
    builder.addCase(deleteTag.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteTag.fulfilled, (state, action) => {
      state.isLoading = false;
      state.tags.data = state.tags.data.filter(
        (product) => product.id !== action.payload.id
      );
      action.payload.enqueueSnackbar("Tag is deleted successfully");
    });

    builder.addCase(deleteTag.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // ==========================
  },
});

export default tagSlice.reducer;
